class InfiniteScroll extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', this.onClickHandler.bind(this));

    if (this.dataset.trigger == 'infinite') {
      new IntersectionObserver(this.handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  async onClickHandler() {
    if (this.classList.contains('loading') || this.classList.contains('disabled')) return;
    this.classList.add('loading');
    this.classList.add('disabled');

    const sections = InfiniteScroll.getSections();
    const url = this.dataset.url;
    const responses = await Promise.all(sections.map(() => InfiniteScroll.renderSectionFromFetch(url)));
    const appendedCount = responses.reduce((sum, item) => sum + item.appendedCount, 0);

    if (appendedCount === 0) {
      const paginationWrapper = document.getElementById('ProductGridContainer')?.querySelector('.pagination-wrapper');
      if (paginationWrapper) paginationWrapper.remove();
    }
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    this.onClickHandler();
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  static renderSectionFromFetch(url) {
    return fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const doc = new DOMParser().parseFromString(responseText, 'text/html');
        const appendedCount = InfiniteScroll.renderProductGridContainer(doc);
        InfiniteScroll.renderPagination(doc);
        return { appendedCount };
      })
      .catch((e) => {
        console.error(e);
        return { appendedCount: 0 };
      });
  }

  static renderPagination(doc) {
    const container = document.getElementById('ProductGridContainer')?.querySelector('.pagination-wrapper');
    if (!container) return;
    const pagination = doc.getElementById('ProductGridContainer')?.querySelector('.pagination-wrapper');
    if (pagination) {
      container.innerHTML = pagination.innerHTML;
    }
    else {
      container.remove();
    }
  }

  static renderProductGridContainer(doc) {
    const container = document.getElementById('product-grid');
    const products = doc.getElementById('product-grid');
    if (!products) return 0;
    const appendedCount = products.querySelectorAll(':scope > .grid__item').length;
    container.insertAdjacentHTML('beforeend', products.innerHTML);
    return appendedCount;
  }
}
customElements.define('infinite-scroll', InfiniteScroll);
